import toast from "react-hot-toast"

/**
 * Wrapper around react-hot-toast matching antd `message` API.
 * Usage: message.success("Done!") / message.error("Failed")
 */
const message = {
  success: (content: string, duration?: number) =>
    toast.success(content, { duration: duration ?? 3000 }),
  error: (content: string, duration?: number) =>
    toast.error(content, { duration: duration ?? 4000 }),
  info: (content: string, duration?: number) =>
    toast(content, { duration: duration ?? 3000 }),
  // caution tone: the 3px left accent is the whole signal \u2014 no icon chip
  warning: (content: string, duration?: number) =>
    toast(content, {
      duration: duration ?? 4000,
      style: { borderLeftColor: "var(--ms-tan)" },
    }),
  loading: (content: string) => toast.loading(content),
  dismiss: (id?: string) => toast.dismiss(id),
}

export { message }
